import karmaEarnListSlice from './slice';

export default karmaEarnListSlice.reducer;
